import { Select, Space } from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import trans from "../../../utils";
import { popupcontext } from "../../../context/Popupscontext";
import {
	useGetAllTechnicianFromUsersQuery,
	useGetTechnicianUnderUserQuery,
} from "../../../Redux/service/Technician/Technician";

export default function FieldStaffMultiInput({
	label,
	styling,
	handleLink,
	handleUnLink,
	vehicleId,
	userId,
	type,
}) {
	const { isLinking } = useContext(popupcontext);
	const [mergedData, setMergedData] = useState([]);
	const [isOpen, setIsOpen] = useState(false);
	const [selectedTechnicians, setSelectedTechnicians] = useState([]);
	const [groups, setGroups] = useState([]);

	// let { data: NotificationsVehicles, refetch: NotificationsVehiclesRefetch } =
	// 	useGetAllTechnicianFromUsersQuery();
	let { data: UserTechnician, refetch: UserTechnicianRefetch } =
		useGetAllTechnicianFromUsersQuery(
			{ page: 1, limit: 10000 },
			{ refetchOnMountOrArgChange: true }
		);
	let { data: Users, refetch: UsersRefetch } = useGetTechnicianUnderUserQuery({
		page: 1,
		limit: 10000,
		userId,
	});
	const handleDropdownVisibleChange = (visible) => {
		if (visible) {
			setIsOpen(true);
		} else {
			setIsOpen(false);
		}
	};
	const isFirstMount = useRef(true);
	// useEffect(() => {
	// 	if (AdminFieldStaff && UsersNotifications) {
	// 		const merged = [
	// 			...AdminFieldStaff?.technicians,
	// 			...UsersNotifications?.fieldWorkers,
	// 		];
	// 		const unique = merged.filter(
	// 			(item, index, self) =>
	// 				index === self.findIndex((t) => t.technician_id === item.id)
	// 		);
	// 		setMergedData(unique);
	// 	}
	// }, [AdminFieldStaff, UsersNotifications]);

	useEffect(() => {
		try {
			// Safely extract arrays
			const customers = Array.isArray(UserTechnician?.fieldWorkers)
				? UserTechnician.fieldWorkers
				: [];
			const users = Array.isArray(Users?.fieldWorkers)
				? Users.fieldWorkers
				: [];

			// Merge safely
			const merged = [...customers, ...users];

			// Ensure items have IDs before filtering
			const unique = merged.filter(
				(item, index, self) =>
					item &&
					item.id &&
					index === self.findIndex((t) => t && t.id === item.id)
			);

			setMergedData(unique);
		} catch (err) {
			console.error("Error merging UserTechnicians and Users:", err, {
				UserTechnician,
				Users,
			});
		}
	}, [UserTechnician, Users]);

	console.log("MergedDataFieldStaff", mergedData);
	useEffect(() => {
		if (isFirstMount.current || UserTechnicianRefetch || UsersRefetch) {
			if (mergedData?.length > 0) {
				setGroups(
					mergedData?.map((i) => ({
						value: i.id,
						label: i.name,
					}))
				);
			}
		}
		isFirstMount.current = false;
	}, [mergedData, UserTechnicianRefetch, UserTechnician, UsersRefetch]);

	useEffect(() => {
		if (type === "users") {
			if (Users) {
				setSelectedTechnicians(Users?.fieldWorkers?.map((i) => i.id));
			}
		}
	}, [Users, type]);

	useEffect(() => {
		if (isLinking) {
			if (type === "users") {
				UsersRefetch();
			}
		}
	}, [isLinking, vehicleId, type, UsersRefetch]);
	return (
		<div className={styling}>
			{label && <div className="mult-input-label">{trans(label)}</div>}
			<Space
				style={{
					width: "100%",
					borderColor: "red",
				}}
				direction="vertical"
			>
				<Select
					mode="multiple"
					style={{
						width: "100%",
						marginTop: "8px",
						borderColor: "red",
					}}
					maxTagCount={"responsive"}
					placeholder={trans("Please select")}
					onSelect={(value) => {
						setSelectedTechnicians((prev) => [...prev, value]);
						handleLink(value, "managedUser", "Field Staff");
					}}
					onDeselect={(value) => {
						setSelectedTechnicians((prev) => prev.filter((v) => v !== value));
						handleUnLink(value, "managedUser", "Field Staff");
					}}
					value={
						(selectedTechnicians?.length > 0 && selectedTechnicians) || null
					}
					options={groups}
					open={isOpen}
					onDropdownVisibleChange={handleDropdownVisibleChange}
					filterOption={(input, option) =>
						option.label.toLowerCase().includes(input.toLowerCase())
					}
				/>
			</Space>
		</div>
	);
}
